<header class="patient-header">
  <div class="patient-identity">
    <div class="avatar">{{ patients.selectedPatient().iniciais }}</div>

    <div class="patient-info">
      <div class="patient-name-row">
        <mat-select
          class="patient-select"
          [ngModel]="patients.selectedPatient().id"
          (ngModelChange)="onPatientChange($event)"
        >
          <mat-option *ngFor="let patient of patients.patients()" [value]="patient.id">
            {{ patient.nome }}
          </mat-option>
        </mat-select>

        <span class="phase-badge">{{ letterLabels[patients.selectedPatient().faseAtual] }}</span>
      </div>

      <div class="patient-meta">
        <span><mat-icon>badge</mat-icon> {{ patients.selectedPatient().cpf }}</span>
        <span><mat-icon>call</mat-icon> {{ patients.selectedPatient().telefone }}</span>
        <span><mat-icon>mail</mat-icon> {{ patients.selectedPatient().email }}</span>
      </div>

      <p class="patient-complaint">Queixa principal: {{ patients.selectedPatient().queixaPrincipal }}</p>
    </div>
  </div>

  <button mat-stroked-button color="primary" (click)="openRegistration()">
    <mat-icon>person</mat-icon>
    Dados do paciente
  </button>
</header>
